import script from "./BoardPreferencesView.vue?vue&type=script&setup=true&lang=js"
export * from "./BoardPreferencesView.vue?vue&type=script&setup=true&lang=js"

import "./BoardPreferencesView.vue?vue&type=style&index=0&id=4b930493&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b930493"]])

export default __exports__